import { useTranslation } from "react-i18next";

import { Badge } from "@nexus/ui";
import type { MarketplaceFulfillmentStatus } from "@nexus/contracts";

import {
  fulfillmentBadgeVariant,
  type MarketplaceFulfillmentViewer,
} from "../lib/fulfillment-badge-variant";
import { getFulfillmentStatusLabel } from "../lib/fulfillment-status-label";

export function FulfillmentStatusBadge({
  status,
  viewer = "client",
  count,
}: {
  status: MarketplaceFulfillmentStatus;
  viewer?: MarketplaceFulfillmentViewer;
  /** When greater than 1, prefixes the label (e.g. `3 × Submitted for feedback`). */
  count?: number;
}) {
  const { t } = useTranslation();
  const statusLabel = getFulfillmentStatusLabel(t, status, viewer);
  const label =
    count !== undefined && count > 1
      ? t("marketplace.videos.statusChipCount", {
          count,
          status: statusLabel,
          defaultValue: "{{count}} × {{status}}",
        })
      : statusLabel;

  return (
    <Badge variant={fulfillmentBadgeVariant(status, viewer)} dot>
      {label}
    </Badge>
  );
}
